import { pipe } from 'fp-ts/lib/function'
import { useQuery } from 'react-query'
import * as axios from './axios-extended'
import * as t from 'io-ts'
import { withFallback } from 'io-ts-types'
import {
  useCurrentWorkspace,
  useOrganizationPermissions,
} from '@library/react-toolkit'

export const useOrganizationByName = (name?: string) => {
  return useQuery(
    ['organizationInfo', name],
    pipe(
      axios.get(`/uaa/api/organizations/${name}`, {
        decoder: withFallback<
          | t.TypeC<{ displayName: t.StringC; crNumber: t.StringC }>
          | t.UndefinedC
        >(t.type({ displayName: t.string, crNumber: t.string }), undefined),
        validateStatus: status => status !== 404,
      }),
      axios.catchNotFound,
      axios.throwLeft
    ),
    { enabled: !!name }
  )
}

export const useIsSmartHubAdmin = () => {
  const org = useOrganizationPermissions()
  const ws = useCurrentWorkspace()
  return (
    ws?.type === 'organization' &&
    ws.organization.name === 'SmartHub' &&
    org?.authority === 'ADMIN'
  )
}

export const useSmartHubType = () =>
  useQuery(
    ['account'],
    pipe(
      axios.get(`/uaa/api/account`, {
        decoder: t.type({
          smartHubType: withFallback(t.string, ''),
        }),
      }),
      axios.throwLeft
    ),
    {}
  )
